import './index.css'
import React from 'react';
import Autocomplete from '../common/Autocomplete';
import TagInput from '../common/TagInput';
import DateTimePicker from '../common/DateTimePicker';


export default function Affectation(props: any) {
  const { action,
    handleSelection,
    ticketForm,
    elementsList,
  } = props

  return (
    <React.Fragment>

      <div className='tkt-form-section'>
        <div className='tkt-form-section-title'>
          <p>Afectación</p>
        </div>

        <div className='tkt-form-section-item'>
          <Autocomplete
            label='Elemento'
            placeholder='Elemento'
            disabled={!(action === 'create' || action === 'edit')}
            options={elementsList}
            name='element'
            value={ticketForm.element}
            handleSelection={handleSelection}
            required
          />
        </div>

        <div className='tkt-form-section-item date'>
          <DateTimePicker
            title='Fecha de Incidencia'
            name='failure_date'
            value={ticketForm.failure_date}
            handleSelection={handleSelection}
            disabled={!(action === 'create' || action === 'edit')}
            disableFuture
          />
        </div>

        <div className='tkt-form-section-item alarms'>
          <TagInput
            label='Alarmas'
            name='alarms'
            placeholder='12345'
            inputType='text'
            values={ticketForm.alarms}
            handleSelection={handleSelection}
            disabled={!(action === 'create' || action === 'edit' || action === 'edit_alarms')}
          />

        </div>

      </div>
    </React.Fragment >
  );
}
